/**
 * Public contact details for the Contact page and mailto/tel links.
 * Set via REACT_APP_CONTACT_* in .env.local. Empty when unset — UI hides missing fields.
 */
const trimEnv = (key: string): string => process.env[key]?.trim() || "";

export const CONTACT_EMAIL = trimEnv("REACT_APP_CONTACT_EMAIL");

export const CONTACT_PHONE = trimEnv("REACT_APP_CONTACT_PHONE");

export const CONTACT_PHONE_HREF =
  trimEnv("REACT_APP_CONTACT_PHONE_HREF") ||
  (CONTACT_PHONE ? CONTACT_PHONE.replace(/\s/g, "") : "");

/** Digits only, for `tel:` / `wa.me` (e.g. 250788000000). */
const CONTACT_PHONE_DIGITS = CONTACT_PHONE_HREF.replace(/\D/g, "");

/**
 * WhatsApp chat URL. Set `REACT_APP_CONTACT_WHATSAPP_URL` to override.
 * Omit env to derive `https://wa.me/<digits>` from phone when configured.
 * Set to empty string to hide WhatsApp on Contact even when phone is set.
 */
export const CONTACT_WHATSAPP_URL = (() => {
  const raw = process.env.REACT_APP_CONTACT_WHATSAPP_URL;
  if (raw !== undefined) {
    return raw.trim();
  }
  return CONTACT_PHONE_DIGITS ? `https://wa.me/${CONTACT_PHONE_DIGITS}` : "";
})();

export const CONTACT_ADDRESS = trimEnv("REACT_APP_CONTACT_ADDRESS");

export const CONTACT_HOURS = trimEnv("REACT_APP_CONTACT_HOURS");
